// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useContext } from "react";

export interface OrderCustomerNumberStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyPresentationProps;
    text?: TypographyPresentationProps;
}

export const orderCustomerNumberStyles: OrderCustomerNumberStyles = {};

const styles = orderCustomerNumberStyles;

const OrderDetailsCustomerNumber = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order || !order.customerNumber) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="orderDetailsCustomerNumber">
                {translate("Customer #")}
            </Typography>
            <Typography
                {...styles.text}
                aria-labelledby="orderDetailsCustomerNumber"
                data-test-selector="orderDetailsCustomerNumber"
            >
                {order.customerNumber}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsCustomerNumber,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
